export default __webpack_public_path__ + "2b7c55345d6182a182c034e39ca2f7f4.svg";